import * as React from 'react';
import * as types from '../../types';
import * as services from '../../services';
import { CrTextField } from '../cr/CrTextField';
import { CrChoiceGroup } from '../cr/CrChoiceGroup';
import { CrCheckbox } from '../cr/CrCheckbox';
import { MessageDialog } from '../cr/MessageDialog';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import styles from '../../styles/cr.module.scss';
import { IGoElement, GoElement } from '../../types';
import { IGenColumn, ColumnType, ColumnDisplayType } from '../../types/GenColumn';
import EvidenceList from './section2/EvidenceList';
import { ElementStatuses } from '../../types/AppGlobals';
import { IChoiceGroupOption } from '@fluentui/react/lib/ChoiceGroup';
import EntityListCat from '../entity/EntityListCat';
import withMobileDetector from '../withMobileDetector';

export interface IUpdateFormProps extends types.IBaseComponentProps {
    filteredItems: any[];
    goElementId: number;
    onShowList: () => void;
    isViewOnly: boolean;
    isMobile: boolean;
}

export interface IUpdateFormState {
    Loading: boolean;
    FormData: IGoElement;
    Evidence_ListFilterText: string;
    UserHelpText: string;
    ShowHelpPanel: boolean;
    GoElementId: number;
    HideNoElementsMessage: boolean;
    HideNextButton: boolean;

}

export class UpdateFormState implements IUpdateFormState {
    public Loading = false;
    public FormData: IGoElement;
    public Evidence_ListFilterText: string = null;
    public UserHelpText: string = null;
    public ShowHelpPanel: boolean = false;
    public GoElementId: number = 0;
    public HideNoElementsMessage: boolean = true;
    public HideNextButton: boolean = false;

    constructor(goFormId: number, goDefElementId: number) {
        this.FormData = new GoElement(goFormId, goDefElementId);
    }
}

class UpdateForm extends React.Component<IUpdateFormProps, IUpdateFormState> {
    private goElementService: services.GoElementService = new services.GoElementService();
    private ratingIcon1: string = require('../../images/goelement/form/1.png');
    private ratingIcon2: string = require('../../images/goelement/form/2.png');
    private ratingIcon3: string = require('../../images/goelement/form/3.png');
    private ratingIcon4: string = require('../../images/goelement/form/4.png');
    private ratingIcon5: string = require('../../images/goelement/form/5.png');
    private ratingIcon6: string = require('../../images/goelement/form/6.png');
    private ratingIcon7: string = require('../../images/goelement/form/7.png');
    private ratingIcon8: string = require('../../images/goelement/form/8.png');
    private ratingIcon9: string = require('../../images/goelement/form/9.png');

    constructor(props: IUpdateFormProps, state: IUpdateFormState) {
        super(props);
        this.state = new UpdateFormState(0, 0);
    }

    public render(): React.ReactElement<IUpdateFormProps> {

        return (
            <React.Fragment>
                {
                    //true
                    (this.state.FormData.ID > 0) && this.state.FormData.GoDefElement
                    && <div className={styles.cr}>
                        {this.renderSectionTitle()}
                        {this.renderInstructions()}
                        {this.renderEvidenceStatement()}
                        {this.renderRatingRadioChoices()}
                        {this.renderEvidencesList()}
                        {this.renderActionsList()}
                        {this.renderFeedbacksList()}
                        {this.renderMarkAsReadyCheckbox()}
                        {this.renderFormButtons()}
                        {this.renderChangeLogs()}

                        <Panel isOpen={this.state.ShowHelpPanel} headerText="" type={PanelType.medium} onDismiss={this.hideHelpPanel} >
                            <div dangerouslySetInnerHTML={{ __html: this.state.UserHelpText }}></div>
                        </Panel>
                        <MessageDialog hidden={this.state.HideNoElementsMessage} title="Information" content="This is the last specific area in your list." handleOk={() => { this.setState({ HideNoElementsMessage: true }); }} />

                    </div>}
            </React.Fragment>
        );
    }

    private renderSectionTitle() {
        return (
            <React.Fragment>
                <h1 className={styles.headings2}>{this.state.FormData.GoDefElement.Title}</h1>
            </React.Fragment>
        );
    }
    private renderInstructions() {

        const { Instructions: shortInstructions, FullInstructions: detailedInstructions } = this.state.FormData.GoDefElement;
        return (
            <React.Fragment>
                <div style={{ marginBottom: '30px' }} className={styles.sectionATitle}>Instructions</div>
                <div>{shortInstructions}</div>
                <div>
                    <span style={{ textDecoration: 'underline', color: 'rgb(0,162,232)', cursor: 'pointer' }}
                        onClick={() => this.showHelpPanel(detailedInstructions)}
                    >Show Detailed Instructions</span>
                </div>
            </React.Fragment>
        );
    }
    private renderEvidenceStatement() {

        return (
            <React.Fragment>
                <div style={{ marginTop: '30px', marginBottom: '15px' }} className={styles.sectionATitle}>Evidence</div>
                <div style={{ fontWeight: "bold", marginBottom: '10px' }}>Please provide your statement of evidence below</div>
                <CrTextField
                    multiline
                    placeholder="Enter details ..."
                    rows={10}
                    maxLength={15000}
                    charCounter={true}
                    onChange={(_, v) => this.changeTextField(v, "EvidenceStatement")}
                    value={this.state.FormData.EvidenceStatement}
                />
            </React.Fragment>
        );
    }

    private renderRatingRadioChoices() {

        const ragRatingStyle: number = this.state.FormData.GoDefElement.RagRatingStyle;
        console.log('rag rating style ', ragRatingStyle);
        let options: IChoiceGroupOption[] = [];

        if (ragRatingStyle === 2) {
            options = [
                { key: '5', imageSrc: this.ratingIcon5, selectedImageSrc: this.ratingIcon5, text: 'Red', imageSize: { width: 44, height: 40 } },
                { key: '6', imageSrc: this.ratingIcon6, selectedImageSrc: this.ratingIcon6, text: 'Red/Amber', imageSize: { width: 44, height: 40 } },
                { key: '7', imageSrc: this.ratingIcon7, selectedImageSrc: this.ratingIcon7, text: 'Amber', imageSize: { width: 44, height: 40 } },
                { key: '8', imageSrc: this.ratingIcon8, selectedImageSrc: this.ratingIcon8, text: 'Amber/Green', imageSize: { width: 44, height: 40 } },
                { key: '9', imageSrc: this.ratingIcon9, selectedImageSrc: this.ratingIcon9, text: 'Green', imageSize: { width: 44, height: 40 } },
            ];
        }
        else {
            //1 or default
            options = [
                { key: '1', imageSrc: this.ratingIcon1, selectedImageSrc: this.ratingIcon1, text: 'Unsatisfactory', imageSize: { width: 44, height: 40 } },
                { key: '2', imageSrc: this.ratingIcon2, selectedImageSrc: this.ratingIcon2, text: 'Limited', imageSize: { width: 44, height: 40 } },
                { key: '3', imageSrc: this.ratingIcon3, selectedImageSrc: this.ratingIcon3, text: 'Moderate', imageSize: { width: 44, height: 40 } },
                { key: '4', imageSrc: this.ratingIcon4, selectedImageSrc: this.ratingIcon4, text: 'Substantial', imageSize: { width: 44, height: 40 } },

            ];
        }

        return (
            <React.Fragment>
                <div style={{ fontWeight: "bold", marginBottom: '10px' }}>Assurance Rating</div>
                <CrChoiceGroup
                    options={options}
                    selectedKey={this.state.FormData.Rating}
                    onChange={(ev, option) => this.changeChoiceGroup(ev, option, "Rating")}
                />
            </React.Fragment>
        );
    }

    private renderEvidencesList() {
        return (
            <React.Fragment>
                <div style={{ marginTop: '30px', fontWeight: "bold", marginBottom: '10px' }}>List evidence documents</div>
                <div style={{ minHeight: '120px' }}>
                    <EvidenceList
                        entityReadAllWithArg1={this.state.FormData.ID}
                        isViewOnlyGoForm={this.props.isViewOnly}
                        filterText={this.state.Evidence_ListFilterText}
                        onChangeFilterText={this.handleEvidence_ChangeFilterText}
                        {...this.props}
                        errorHandling={this.props.errorHandling}
                    />
                </div>

            </React.Fragment>
        );
    }

    private renderActionsList() {
        const listColumns: IGenColumn[] = [
            {
                key: 'GoElementId',
                columnDisplayType: ColumnDisplayType.FormOnly,
                fieldDisabled: true,
                fieldHiddenInForm: true,
                fieldDefaultValue: this.state.FormData.ID,
                columnType: ColumnType.TextBox,
                name: 'GoElementId',
                fieldName: 'GoElementId',
                minWidth: 1,
                isResizable: true,
                isRequired: true,
            },
            {
                key: 'Title',
                columnType: ColumnType.TextBox,
                isMultiline: true,
                name: 'Action',
                fieldName: 'Title',
                minWidth: this.props.isMobile ? 80 : 150,
                maxWidth: this.props.isMobile ? 100 : 250,
                isResizable: true,
                isRequired: true,
                fieldMaxLength: 500,
                headerClassName: styles.bold,
            },
            {
                key: 'EntityPriorityTitle',
                columnType: ColumnType.DropDown,
                name: 'Priority',
                fieldName: 'EntityPriorityTitle',
                idFieldName: 'EntityPriorityId',
                isParent: true,
                parentEntityName: 'EntityPriority',
                parentColumnName: 'Title',
                parentService: new services.EntityPriorityService(),
                minWidth: 80,
                maxWidth: 100,
                isCollapsible: true,
                isResizable: true,
                isRequired: true,
                headerClassName: styles.bold,
            },
            {
                key: 'Timescale',
                columnType: ColumnType.TextBox,
                name: 'Timescale',
                fieldName: 'Timescale',
                minWidth: 100,
                maxWidth: 120,
                isResizable: true,
                isCollapsible: true,
                isMultiline: true,
                isRequired: true,
                fieldMaxLength: 100,
                headerClassName: styles.bold,
            },
            {
                key: 'Owner',
                columnType: ColumnType.TextBox,
                isMultiline: true,
                name: 'Owner',
                fieldName: 'Owner',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true,
                isCollapsible: true,
                isRequired: true,
                fieldMaxLength: 100,
                headerClassName: styles.bold,
            },
            {
                key: 'Progress',
                columnType: ColumnType.TextBox,
                numRows: 5,
                name: 'Progress',
                fieldName: 'Progress',
                minWidth: 120,
                maxWidth: 500,
                isResizable: true,
                isRequired: true,
                isMultiline: true,
                fieldMaxLength: 15000,
                headerClassName: styles.bold,
            },
        ];

        return (
            <React.Fragment>
                <div style={{ marginTop: '30px', fontWeight: "bold", marginBottom: '10px' }}>Action Plan</div>
                <div style={{ minHeight: '120px' }}>
                    <EntityListCat
                        entityReadAllWithArg1={this.state.FormData.ID}
                        allowAdd={!this.props.isViewOnly}
                        columns={listColumns}
                        {...this.props}
                        errorHandling={this.props.errorHandling}
                        entityService={new services.GoElementActionService()}
                        entityNamePlural="Actions"
                        entityNameSingular="Action"
                        childEntityNameApi=""
                        childEntityNamePlural=""
                        childEntityNameSingular=""
                        zeroMarginTop={true}
                        hideTitleBelowCommandBar={true}
                    />
                </div>

            </React.Fragment>
        );
    }

    private renderFeedbacksList() {
        const listColumns: IGenColumn[] = [
            {
                key: 'GoElementId',
                columnDisplayType: ColumnDisplayType.FormOnly,
                fieldDisabled: true,
                fieldHiddenInForm: true,
                fieldDefaultValue: this.state.FormData.ID,
                columnType: ColumnType.TextBox,
                name: 'GoElementId',
                fieldName: 'GoElementId',
                minWidth: 1,
                isResizable: true,
                isRequired: true,
            },
            {
                key: 'UserUsername',
                columnType: ColumnType.DisplayInListOnly,
                name: 'Comment By',
                fieldName: 'UserUsername',
                isParent: true,
                parentEntityName: 'CommentBy',
                parentColumnName: 'Title',
                minWidth: 80,
                maxWidth: 120,
                isResizable: true,
                isRequired: true,
                headerClassName: styles.bold,
            },
            {
                key: 'CommentDate',
                columnType: ColumnType.DatePicker,
                showDateAndTimeInList: true,
                columnDisplayType: ColumnDisplayType.ListOnly,
                name: 'Date/Time',
                fieldName: 'CommentDate',
                minWidth: 100,
                maxWidth: 120,
                isCollapsible: true,
                isResizable: true,
                fieldMaxLength: 100,
                headerClassName: styles.bold,
            },
            {
                key: 'Comment',
                columnType: ColumnType.TextBox,
                name: 'Comment',
                fieldName: 'Comment',
                minWidth: 200,
                isResizable: true,
                isRequired: true,
                fieldMaxLength: 15000,
                isMultiline: true,
                numRows: 5,
                headerClassName: styles.bold,
            },
        ];

        return (
            <React.Fragment>
                <div style={{ marginTop: '30px', fontWeight: "bold", marginBottom: '10px' }}>Feedback and General Comments</div>
                <div style={{ minHeight: '120px' }}>
                    <EntityListCat
                        entityReadAllWithArg1={this.state.FormData.ID}
                        allowAdd={true}
                        columns={listColumns}
                        {...this.props}
                        errorHandling={this.props.errorHandling}
                        entityService={new services.GoElementFeedbackService()}
                        entityNamePlural="Comments"
                        entityNameSingular="Comment"
                        childEntityNameApi=""
                        childEntityNamePlural=""
                        childEntityNameSingular=""
                        zeroMarginTop={true}
                        hideTitleBelowCommandBar={true}
                    />
                </div>
                <div style={{ paddingTop: "10px", fontStyle: "italic" }}>
                    This area can be used to leave comments for other users as this section of the Statement is being completed.
                </div>

            </React.Fragment>
        );
    }

    private renderMarkAsReadyCheckbox() {
        if (this.props.isViewOnly === false) {
            return (
                <div style={{ paddingTop: "35px" }}>
                    <CrCheckbox
                        className={`${styles.checkbox}`}
                        //style={{marginBottom:"10px"}} //TODO check this why its not working
                        label="Mark as Completed"
                        checked={this.state.FormData.MarkReadyForApproval}
                        onChange={(ev, isChecked) => this.changeCheckbox(isChecked, "MarkReadyForApproval")}
                        disabled={!this.validateForStatus()}
                    />
                </div>
            );
        }
        else
            return null;
    }

    private renderFormButtons() {
        return (
            <div>
                {(this.props.isViewOnly === false) &&
                    <React.Fragment>
                        {(this.state.HideNextButton === false) && <PrimaryButton text="Save &amp; Next" className={styles.formButton} style={{ marginRight: '5px' }}
                            onClick={() => this.onBeforeSave(true)}
                        />}
                        <PrimaryButton text="Save &amp; Close" className={styles.formButton} style={{ marginRight: '5px' }}
                            onClick={() => this.onBeforeSave(false)}
                        />
                        <DefaultButton text="Cancel" className={styles.formButton} style={{ marginRight: '5px' }}
                            onClick={this.props.onShowList}
                        />
                    </React.Fragment>
                }

                {(this.props.isViewOnly === true) &&
                    <div style={{ marginTop: '20px' }}>
                        {(this.state.HideNextButton === false) && <PrimaryButton text="Next" className={styles.formButton} style={{ marginRight: '5px' }}
                            onClick={() => this.showNext()}
                        />}
                        <DefaultButton text="Close" className={styles.formButton} style={{ marginRight: '5px' }}
                            onClick={this.props.onShowList}
                        />
                    </div>
                }

            </div>
        );
    }

    private renderChangeLogs() {
        const fd = this.state.FormData;
        let changeLog = fd.GoElementChangeLog ? fd.GoElementChangeLog : "";
        let changeLogArr = changeLog.split(',');
        let changeLogs = "";
        changeLogArr.reverse().forEach(log => {
            if (log.length > 0) {
                changeLogs += `${log}<br />`;
            }
        });

        return (
            <React.Fragment>
                <div style={{ marginTop: "30px" }}>
                    <div style={{ fontWeight: 'bold' }}>Change Log:</div>
                    <div style={{ marginTop: "20px" }} dangerouslySetInnerHTML={{ __html: changeLogs }} />
                </div>
            </React.Fragment>
        );
    }

    private loadGoElement = (firstLoad: boolean): Promise<void | IGoElement> => {

        return this.goElementService.readWithExpandDefElement(this.state.GoElementId).then((e: IGoElement) => {
            console.log('GoElement: ', e);
            if (firstLoad === false) {
                //if we need to send info to parent component after loading next goElement- do it here
            }

            //check if this is the last record or not in the props.filteredItems
            const lastGoElementId_FilteredItems: number = Number(this.props.filteredItems[this.props.filteredItems.length - 1]["GoElementId"]);
            const goElementId_Current: number = Number(this.state.GoElementId);
            let hideNextButton: boolean = false;
            if (goElementId_Current === lastGoElementId_FilteredItems) {
                hideNextButton = true;
            }

            this.setState({ FormData: e, HideNextButton: hideNextButton });
            return e;

        }, (err) => {
            if (this.props.errorHandling?.onError) this.props.errorHandling?.onError(`Error loading GoElement`, err.message);
        });
    }

    private loadLookups(): Promise<any> {
        return Promise.all([
        ]);
    }

    public componentDidMount(): void {
        this.setState({ Loading: true, GoElementId: this.props.goElementId }, this.callBackFirstLoad
        );
    }

    private callBackFirstLoad = (): void => {
        let loadingPromises = [this.loadLookups()];
        if (this.state.GoElementId > 0) {
            loadingPromises.push(this.loadGoElement(true));
        }
        Promise.all(loadingPromises).then(p => this.setState({ Loading: false })).catch(err => this.setState({ Loading: false }));
    }

    protected validateForStatus = (): boolean => {
        if (this.state.FormData.Rating === null) {
            return false;
        }
        if (this.state.FormData.EvidenceStatement && this.state.FormData.EvidenceStatement.length >= 10) {
            //true
        }
        else {
            return false;
        }
        return true;
    }

    protected onBeforeSave = (showNext: boolean): void => {
        let completionStatus: string = ElementStatuses.InProgress; //taking as default
        let markReadyForApproval: boolean = this.state.FormData.MarkReadyForApproval;

        const completed: boolean = this.validateForStatus();
        if (completed === true) {
            if (markReadyForApproval === true) {
                completionStatus = ElementStatuses.Completed;
            }
        }
        else {
            completionStatus = ElementStatuses.InProgress;
            //also uncheck the mark as ready checkbox
            markReadyForApproval = false;
        }

        const newFormData = { ...this.state.FormData, "CompletionStatus": completionStatus, "MarkReadyForApproval": markReadyForApproval };
        this.setState({ FormData: newFormData }, () => this.saveUpdate(showNext));
    }

    protected saveUpdate = (showNext: boolean): void => {

        if (this.validateEntityUpdate()) {
            const formData: IGoElement = { ...this.state.FormData };
            delete formData.GoDefElement;
            delete formData.GoForm;
            delete formData.GoAssignments;
            this.goElementService.updatePut(formData.ID, formData).then((): void => {

                if (this.props.errorHandling?.onError)
                    this.props.errorHandling?.onError(null);

                if (showNext === true) {
                    this.showNext();
                }
                else {
                    this.props.onShowList();
                }

            }, (err) => {
                if (this.props.errorHandling?.onError)
                    this.props.errorHandling?.onError(`Error saving Element update`, err.message);
            });
        }
    }

    private showNext = (): void => {
        const currentGoElementID: number = Number(this.state.GoElementId);
        let currentIDFound: boolean = false;
        let nextGoElementID: number = 0;

        for (let i = 0; i < this.props.filteredItems.length; i++) {
            let e: any = this.props.filteredItems[i];
            const id: number = Number(e["GoElementId"]);

            if (id === currentGoElementID) {
                currentIDFound = true;
                continue;
            }
            if (currentIDFound === true) {
                nextGoElementID = id;
                break;
            }
        }

        if (nextGoElementID > 0) {
            this.setState({
                GoElementId: nextGoElementID,
            }, () => this.loadGoElement(false));
        }
        else {

            //this condition will not run cause we are already hiding next buttons
            this.setState({
                HideNoElementsMessage: false,
            });
        }

    }

    protected validateEntityUpdate = (): boolean => {
        return true;
    }

    protected changeChoiceGroup = (ev, option: IChoiceGroupOption, f: string): void => {
        const selectedKey = option.key;
        this.setState({ FormData: this.cloneObject(this.state.FormData, f, selectedKey)/*, FormIsDirty: true*/ });

    }

    protected changeTextField = (value: string, f: string): void => {
        this.setState({ FormData: this.cloneObject(this.state.FormData, f, value)/*, FormIsDirty: true*/ });
    }

    protected changeCheckbox = (value: boolean, f: string): void => {
        this.setState({ FormData: this.cloneObject(this.state.FormData, f, value)/*, FormIsDirty: true*/ });
    }

    protected cloneObject(obj, changeProp?, changeValue?) {
        if (changeProp)
            return { ...obj, [changeProp]: changeValue };
        return { ...obj };
    }

    private handleEvidence_ChangeFilterText = (value: string): void => {
        this.setState({ Evidence_ListFilterText: value });
    }

    private showHelpPanel = (helpText: string) => {
        this.setState({ UserHelpText: helpText, ShowHelpPanel: true });
    }

    private hideHelpPanel = () => {
        this.setState({ ShowHelpPanel: false });
    }
}

export default withMobileDetector(UpdateForm);